import { ca } from '@cian/analytics';

export function trackCheckAdClick() {
  ca('event', {
    action: 'Click',
    category: 'VerificationPopup',
    label: 'Check_ad_from_ad_page',
    name: 'oldevent',
  });
}
